import { act } from "react";

export const filterVariants = ( productObject, embroideryOptionPosition, embroidery = false, sizeOptionPosition = 1, activeSize = null ) => {
  const embroideryVal = embroidery ? 'embroidery' : 'no embroidery'
  const variants = productObject.variants.filter(variant => {
    // if no variants are setup
    if (variant.title === 'Default Title') return variant

    if (activeSize !== null && embroideryOptionPosition) {
      // grab embroidery/non-embroidery + current (size)
      return (variant[`option${sizeOptionPosition}`] === activeSize && variant[`option${embroideryOptionPosition}`].toLowerCase() === embroideryVal)
    }
    if(embroideryOptionPosition){
       // grab embroidery/non-embroidery variants
    return (variant[`option${embroideryOptionPosition}`].toLowerCase() === embroideryVal)
    }
    else{
      if(sizeOptionPosition>1){
      return(variant[`option${sizeOptionPosition}`] === activeSize)
      }
      else{
      return variant;
      }
    }
  })

  return variants
}
